var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.title,
        primaryAction: {
          label: _vm.$t.__("common.actions.close"),
          action: function() {
            return (_vm.showModal = false)
          }
        }
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      [
        _c("div", {
          staticClass: "typographies-paragraph-medium-regular",
          domProps: { innerHTML: _vm._s(_vm.message) }
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }